import React from "react";
import { Link } from "react-router-dom";
import { Battery, Gauge, ArrowRight } from "lucide-react";
import { useLang, localized } from "../i18n/LanguageContext";
import { fromPerDay } from "../lib/pricing";
import { Button } from "./ui/button";

const ProductCard = ({ product, index = 0 }) => {
  const { lang, tr, lp } = useLang();
  const name = localized(product.name, lang);
  const short = localized(product.short, lang);
  return (
    <div data-testid={`product-card-${product.category}`} className="group bg-white rounded-3xl border border-slate-100 shadow-md overflow-hidden flex flex-col animate-fade-up" style={{ animationDelay: `${index * 80}ms` }}>
      <div className="aspect-[4/3] bg-slate-50 overflow-hidden">
        <img src={product.image} alt={name} loading="lazy" className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
      </div>
      <div className="p-6 flex flex-col flex-1">
        <h3 className="font-heading font-bold text-xl text-ink mb-2">{name}</h3>
        <p className="text-base text-ink-muted leading-relaxed mb-4 flex-1">{short}</p>
        <div className="flex items-center gap-4 text-sm text-ink-muted mb-4">
          {product.specs?.autonomy_km > 0 && <span className="flex items-center gap-1.5"><Battery className="w-4 h-4 text-brand" /> {product.specs.autonomy_km} km</span>}
          <span className="flex items-center gap-1.5"><Gauge className="w-4 h-4 text-brand" /> {product.specs?.max_user_weight_kg} kg</span>
        </div>
        <div className="mb-4">
          <span className="text-sm text-ink-muted">{tr.booking.from}</span>
          <div className="font-heading font-extrabold text-2xl text-brand">{fromPerDay(product)} €<span className="text-base font-medium text-ink-muted">{tr.products.perDay}</span></div>
          <div className="text-xs text-ink-muted mt-0.5">{tr.products.from7}</div>
        </div>
        <div className="flex gap-2">
          <Link to={lp(`/produit/${product.slug}`)} className="flex-1">
            <Button variant="outline" data-testid={`product-details-${product.category}`} className="w-full rounded-full h-12 border-2 font-semibold text-base">{tr.products.details}</Button>
          </Link>
          <Link to={`${lp("/reservation")}?product=${product.id}`} className="flex-1">
            <Button data-testid={`product-book-${product.category}`} className="w-full rounded-full h-12 bg-brand hover:bg-brand-hover text-white font-bold text-base">{tr.products.book} <ArrowRight className="w-4 h-4 ml-1" /></Button>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default ProductCard;
